// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3cskC","name":"styles_name__3MrUc","phone":"styles_phone__7HV5e"};